import { useCallback, useState } from 'react';

export const CURRENCY_MODE = {
  FOREIGN: 'FOREIGN',
  JPY: 'JPY',
} as const;
export type CurrencyMode = typeof CURRENCY_MODE[keyof typeof CURRENCY_MODE];

export const useCurrencyMode = (): {
  currencyMode: CurrencyMode;
  toggle: () => void;
} => {
  const [mode, setMode] = useState<CurrencyMode>(CURRENCY_MODE.JPY);
  const toggle = useCallback(() => {
    setMode(prev =>
      prev === CURRENCY_MODE.JPY ? CURRENCY_MODE.FOREIGN : CURRENCY_MODE.JPY
    );
  }, []);
  return { currencyMode: mode, toggle };
};
